import { useState } from "react";
import { Button } from "../../components/button";
import { ButtonIntent } from "../../components/button/button.styles";
import { Container } from "../../components/container";
import { Navbar } from "../../components/navbar";
import { CheckStatusModal } from "../../components/check-status-modal";

import { cn } from "../../lib/cn";

import HERO_BACKGROUND from "../../images/new-design/hero-background.png";
import BLUE_LOGO from "../../images/new-design/blue-logo.svg";
import APP_STORE from "../../images/new-design/app-store.png";

function Hero() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section
      className="h-screen bg-cover bg-center max-h-[850px]"
      style={{ backgroundImage: `url(${HERO_BACKGROUND})` }}
      aria-label="Hero section"
    >
      <Container className="flex flex-col h-full">
        <Navbar />

        <div className="flex flex-col items-center justify-center flex-1">
          <div className="flex items-start justify-center w-full relative h-32">
            <span className="h-32 w-[1px] bg-white absolute -top-8 left-1/2 -translate-x-1/2"></span>
          </div>
          <h1
            className={cn([
              "text-[37px] text-center leading-[120%] text-white",
              "lg:text-[56px]",
            ])}
          >
            <span className="font-ppacma">Curated Connections,</span> <br />{" "}
            <span className="font-montreal font-medium">
              Wherever The Game Takes You.
            </span>
          </h1>

          <img alt="League Life Logo" src={BLUE_LOGO} className="mt-8" />
          <a
            href="https://apps.apple.com/us/app/league-life/id1612547898"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Download League Life on the App Store"
            className="mx-auto"
          >
            <img
              alt="Download on the App Store"
              src={APP_STORE}
              className={cn(["mt-5 w-[146px] h-auto mx-auto", "lg:w-[200px]"])}
              loading="eager"
            />
          </a>

          <div
            className={cn([
              "gap-2 flex flex-col items-center mt-12",
              "lg:hidden",
            ])}
          >
            <a
              href="https://abi38wtuwac.typeform.com/to/Q3gHPxSM"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                intent={ButtonIntent.Black}
                aria-label="Request access to League Life"
              >
                Request access
              </Button>
            </a>
            <Button
              onClick={() => setIsModalOpen(true)}
              aria-label="Check your application status"
            >
              Check your status
            </Button>
          </div>
        </div>
      </Container>

      {/* Check Status Modal */}
      <CheckStatusModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
}

export { Hero };
